import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import { entitiesReducer, userReducer } from "shared-frontend/redux/reducers";
import { uiResetPasswordReducer } from "./resetPassword";
import { uiLoginReducer } from "./login";
import { uiSignupReducer } from "./signup";
import { uiActivateReducer } from "./activate";
import { uiHomeReducer } from "./home";
import { uiSiteReducer } from "./site.js";
import { uiSearch } from "./search.js";
import { uiInvoicesReducer } from "./invoices";
import { uiSitesReducer } from "./sites.js";
import {
	uiAddSubscriptionModalReducer,
	uiAllSubscriptionsReducer,
	uiCancelSubscriptionsReducer,
} from "./subscriptions.js";
import { uiOrdersReducer } from "./orders";
import { uiRefundsReducer } from "./refunds";
import { uiAllProductGroupsReducer } from "./productGroups";


export const uiReducer = combineReducers( {
	home: uiHomeReducer,
	sites: uiSitesReducer,
	site: uiSiteReducer,
	search: uiSearch,
	subscriptions: uiAllSubscriptionsReducer,
	subscriptionsCancel: uiCancelSubscriptionsReducer,
	productGroups: uiAllProductGroupsReducer,
	orders: uiOrdersReducer,
	invoiceModal: uiInvoicesReducer,
	refunds: uiRefundsReducer,
	addSubscriptionModal: uiAddSubscriptionModalReducer,
	resetPassword: uiResetPasswordReducer,
	login: uiLoginReducer,
	signup: uiSignupReducer,
	activate: uiActivateReducer,
} );


export default ( history ) => combineReducers( {
	ui: uiReducer,
	user: userReducer,
	entities: entitiesReducer,
	router: connectRouter( history ),
} );
